import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SearchCacheService {
  private storageKey = 'searchFilterCache';

  private loadStore(): { [key: string]: any } {
    const data = localStorage.getItem(this.storageKey);
    return data ? JSON.parse(data) : {};
  }

  private saveStore(store: { [key: string]: any }): void {
    localStorage.setItem(this.storageKey, JSON.stringify(store));
  }
// query- This holds actual filter criteria
// isFilterActive- Used to find any filters crieteeris ia acrive, so wec can use to to eanble clear all
  save(key: string, data: { query: any; isFilterActive: boolean; campaignId?: number }): void {
    const store = this.loadStore();
    store[key] = data;
    this.saveStore(store);
  }

  get(key: string): { query: any; isFilterActive: boolean; campaignId?: number } | null {
    const store = this.loadStore();
    return store[key] || null;
  }

  clear(key: string): void {
    const store = this.loadStore();
    delete store[key];
    this.saveStore(store);
  }

  clearAll(): void {
    localStorage.removeItem(this.storageKey);
  }

  getAll(): { [key: string]: { query: any; isFilterActive: boolean; campaignId?: number } } {
    return this.loadStore();
  }
}
